import {
	Button,
	CompanySettings,
	InputText,
	StylovyzeTableRow,
} from '@innovyze/stylovyze';
import { RemoveCircle } from '@mui/icons-material';
import { SensorDataPoint, SensorPointsFormikProps } from '@Types';
import { generateLuxonFormatToken } from '@Utils/generateLuxonFormatToken';
import { FormikContextType } from 'formik';
import { DateTime } from 'luxon';
import React from 'react';

interface EditSensorDataTableProps {
	point: SensorDataPoint;
	index: number;
	companySettings: CompanySettings;
	loading: boolean;
	formikProps: FormikContextType<SensorPointsFormikProps>;
}

export default function editSensorRow({
	point,
	index,
	companySettings,
	loading,
	formikProps,
}: EditSensorDataTableProps): StylovyzeTableRow {
	const { timeZoneIANA } = companySettings;
	const { setFieldValue, values } = formikProps;
	const { points } = values;
	const luxonFormat = generateLuxonFormatToken(companySettings);

	const dateFormatted = DateTime.fromMillis(point.timestamp.timeInSeconds)
		.setZone(timeZoneIANA)
		.toFormat(luxonFormat);

	const editSensorInput = (
		<InputText
			dataCy="newValueField"
			key={`editSensorData-newValue-${point.timestamp}`}
			fieldAttrs={{ name: `points.${index}.newValue` }}
			textField={{
				label: '',
				style: {
					width: 100,
				},
				type: 'number',
				className: 'editSensorData-newValue',
				disabled: loading,
				onKeyDown: (e: React.KeyboardEvent<HTMLInputElement>) =>
					new Set(['+', '*', '/', 'e', '(', ')']).has(e.key) &&
					e.preventDefault(),
			}}
		/>
	);

	const deleteButton = (
		<Button
			dataCy="deleteRowButton"
			color="secondary"
			key={`editSensorData-delete-${point.timestamp}`}
			disabled={loading}
			onClick={() => {
				setFieldValue(
					'points',
					points?.filter((_, i) => i !== index) || [],
				);
			}}>
			<RemoveCircle />
		</Button>
	);

	return {
		key: `editSensorData-row-${point.timestamp}-${index}`,
		cells: [
			dateFormatted,
			point.value.doubleValue,
			editSensorInput,
			deleteButton,
		],
	};
}
